import _ from "lodash";
const isValidNumber = value => {
  const parts = _.split(value, ".");

  // If there's more than one part, ensure both parts are numeric
  if (_.size(parts) === 2) {
    return !isNaN(parts[0]) && !isNaN(parts[1]);
  }

  // If there's only one part, ensure it's numeric
  if (_.size(parts) === 1) {
    return !isNaN(parts[0]);
  }

  // If there are more than two parts, it's not a valid decimal number
  return false;
};

const removeLeadingZeroes = value => {
  if (_.startsWith(value, "0") && value.length > 1 && value[1] != ".") {
    // If it starts with '0' and has more than one character such that second character is not decimal, remove the leading zero
    return _.slice(value, 1);
  }
  return value;
};

const findDuplicates = arr => {
  const seen = new Set();
  const duplicates = new Set();

  _.forEach(arr, num => {
    if (seen.has(num)) {
      duplicates.add(num);
    } else {
      seen.add(num);
    }
  });

  return _.filter([...duplicates], val => !_.isNil(val));
};

export { isValidNumber, removeLeadingZeroes, findDuplicates };
